import floorImg from '../../assets/floor.png';
import corridorV01Img from '../../assets/corridor_v01.png';
import corridorV02Img from '../../assets/corridor_v02.png';
import corridorV03Img from '../../assets/corridor_v03.png';
import corridorV04Img from '../../assets/corridor_v04.png';
import corridorV05Img from '../../assets/corridor_v05.png';
import corridorV06Img from '../../assets/corridor_v06.png';
import corridorV07Img from '../../assets/corridor_v07.png';
import corridorV08Img from '../../assets/corridor_v08.png';
import corridorV09Img from '../../assets/corridor_v09.png';
import corridorV10Img from '../../assets/corridor_v10.png';
import corruptedCorridor1Img from '../../assets/corrupted_corridor1.png';
import corruptedCorridor2Img from '../../assets/corrupted_corridor2.png';
import corruptedCorridor3Img from '../../assets/corrupted_corridor3.png';
import corruptedCorridor4Img from '../../assets/corrupted_corridor4.png';
import corruptedCorridor5Img from '../../assets/corrupted_corridor5.png';

import statue1Img from '../../assets/statues/statue1.png';
import statue2Img from '../../assets/statues/statue2.png';
import statue3Img from '../../assets/statues/statue3.png';
import statue4Img from '../../assets/statues/statue4.png';
import statue5Img from '../../assets/statues/statue5.png';
import statue6Img from '../../assets/statues/statue6.png';
import statue7Img from '../../assets/statues/statue7.png';
import statue8Img from '../../assets/statues/statue8.png';
import statue9Img from '../../assets/statues/statue9.png';
import statue10Img from '../../assets/statues/statue10.png';

import { getFloorMoodTilesetId } from './floorMoods';

export const corridorImgs = [
  corridorV01Img,
  corridorV02Img,
  corridorV03Img,
  corridorV04Img,
  corridorV05Img,
  corridorV06Img,
  corridorV07Img,
  corridorV08Img,
  corridorV09Img,
  corridorV10Img,
];

const corruptedCorridorImgs = [
  corruptedCorridor1Img,
  corruptedCorridor2Img,
  corruptedCorridor3Img,
  corruptedCorridor4Img,
  corruptedCorridor5Img,
];

const normalFloorPool11 = [
  floorImg,
  ...corridorImgs,
];

export const FLOOR_TILESET_PROFILES = {
  default: {
    id: 'default',
    floorBaseImg: floorImg,
    corridorImgs,
    filter: {
      brightness: 1,
      contrast: 1,
      saturate: 1,
      sepia: 0,
      hueRotate: 0,
    },
    overlay: null,
    overlayBlendMode: 'multiply',
  },

  corrupted: {
    id: 'corrupted',
    floorBaseImg: corruptedCorridor1Img,
    corridorImgs: [
      ...corruptedCorridorImgs,
      ...normalFloorPool11,
    ],
    filter: {
      brightness: 1,
      contrast: 1,
      saturate: 1,
      sepia: 0,
      hueRotate: 0,
    },
    overlay: null,
    overlayBlendMode: 'multiply',
  },
};

export function getFloorTilesetProfile(input) {
  const tilesetId = getFloorMoodTilesetId(input);
  return FLOOR_TILESET_PROFILES[tilesetId] || FLOOR_TILESET_PROFILES.default;
}

export const SECRET_STATUE_TILE_TO_IMG = {
  'statue-1': statue1Img,
  'statue-2': statue2Img,
  'statue-3': statue3Img,
  'statue-4': statue4Img,
  'statue-5': statue5Img,
  'statue-6': statue6Img,
  'statue-7': statue7Img,
  'statue-8': statue8Img,
  'statue-9': statue9Img,
  'statue-10': statue10Img,
};

export function buildAOLayer() {
  return `radial-gradient(closest-side, rgba(0,0,0,0) 55%, rgba(0,0,0,0.30) 100%)`;
}

function hash32(a) {
  a |= 0;
  a = (a ^ 61) ^ (a >>> 16);
  a = a + (a << 3);
  a = a ^ (a >>> 4);
  a = Math.imul(a, 0x27d4eb2d);
  a = a ^ (a >>> 15);
  return a >>> 0;
}

export function hash01(x, y, seed) {
  const h = hash32((x * 374761393) ^ (y * 668265263) ^ (seed * 1442695041));
  return h / 4294967295;
}

export function buildGrimeLayers(x, y, seed) {
  const n1 = hash01(x, y, seed);
  const n2 = hash01(x + 11, y - 7, seed);
  const n3 = hash01(x - 3, y + 19, seed);

  const cx1 = Math.floor(n1 * 100);
  const cy1 = Math.floor(n2 * 100);
  const r1 = 35 + Math.floor(n3 * 35);

  const cx2 = Math.floor(hash01(x + 101, y + 17, seed) * 100);
  const cy2 = Math.floor(hash01(x - 37, y + 53, seed) * 100);
  const r2 = 25 + Math.floor(hash01(x + 9, y + 91, seed) * 40);

  const o1 = 0.06 + hash01(x + 5, y + 5, seed) * 0.07;
  const o2 = 0.04 + hash01(x + 77, y - 13, seed) * 0.06;

  return [
    `radial-gradient(circle at ${cx1}% ${cy1}%, rgba(0,0,0,${o1.toFixed(3)}) 0%, rgba(0,0,0,0) ${r1}%)`,
    `radial-gradient(circle at ${cx2}% ${cy2}%, rgba(0,0,0,${o2.toFixed(3)}) 0%, rgba(0,0,0,0) ${r2}%)`,
  ];
}